export default () => ({
    root: {
        marginLeft: 250
    },
    button: {
        marginBottom: 20
    }
})